import React from 'react'

interface SchemaField {
  field_name: string
  data_type: string
  is_required: boolean
  canonical_field: string
  validation_rules_count: number
}

interface SchemaSectionProps {
  schemaFields: SchemaField[]
}

const SchemaSection: React.FC<SchemaSectionProps> = ({ schemaFields }) => {
  return (
    <div className="file-schema-section">
      <h3 className="section-title">Schema Overview</h3>
      <div className="schema-fields">
        {schemaFields.length > 0 ? (
          schemaFields.map((field) => (
            <div key={field.field_name} className="schema-field">
              <span className="field-name">{field.field_name}</span>
              <span className="field-type">({field.data_type})</span>
              { <span className="field-required">*</span>}
            </div>
          ))
        ) : (
          <div className="schema-field">
            <span className="field-name">No schema data available</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default SchemaSection
